import angular from "angular";
import Vue from "vue";
import "ngVue";

import RoadmapsList from "./RoadmapsList.vue";

export default angular
  .module("directives.roadmapslist", [])
  .directive("dcRoadmapsList", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcRoadmapsList", RoadmapsList));
    },
  ]);
